<template>
    <li>
        <router-link v-if="to" :to="to" :class="classes" :data-toggle="dataToggle" :data-target="dataTarget"><slot></slot></router-link>
        <a v-else-if="href" :class="classes" :href="href" :data-toggle="dataToggle" :data-target="dataTarget"><slot></slot></a>
        <a v-else :class="classes" @click="click" :data-toggle="dataToggle" :data-target="dataTarget"><slot></slot></a>
    </li>
</template>

<script>
export default {
    name: "DropdownItem",
    props: {
        to: {
            type: String,
            required: false,
            default: undefined
        },
        href: {
            type: String,
            required: false,
            default: undefined
        },
        closeOnClick: {
            type: Boolean,
            required: false,
            default: true
        },
        selected: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        classes: function() {
            return {
                'dropdown-item': true,
                'selected': this.selected
            }
        },
        dataToggle: function() {
            return this.closeOnClick ? 'collapse' : '';
        },
        dataTarget: function() {
            return this.closeOnClick ? '.navbar-collapse.show' : '';
        }
    },
    methods: {
        click: function() {
            this.$emit('click');
        },
    }
}
</script>

<style lang="scss" scoped>

.dropdown-item {
    cursor: pointer;
    border: none;
    color: $text-color !important;
    font-size: 14px;
    font-family: 'Noto Serif SC', serif;
    font-weight: 400;
    padding: 10px;
    text-transform: capitalize;
    &:hover {
        background-color: $primary-color !important;
        color: $white !important;

    }

    &:hover a, &:hover a span {
        color: $white !important;
    }
}

.selected {
    // background-color: $primary-color !important;
    color: $primary-dark !important;



}


@media (max-width: 991.98px) {
    .selected {
        .fa-caret-right {
            -webkit-transform: rotate(90deg);
            -moz-transform: rotate(90deg);
            -ms-transform: rotate(90deg);
            -o-transform: rotate(90deg);
            transform: rotate(90deg);
        }
    }

    .dropdown-item {
        color: $white !important;
    }

}
</style>

